import { render, staticRenderFns } from "./SocialButton.vue?vue&type=template&id=148c8d58&scoped=true&"
import script from "./SocialButton.vue?vue&type=script&lang=js&"
export * from "./SocialButton.vue?vue&type=script&lang=js&"
import style0 from "./SocialButton.vue?vue&type=style&index=0&id=148c8d58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148c8d58",
  null
  
)

export default component.exports